var _linearGradient, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExcel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    gradientUnits: "userSpaceOnUse",
    x1: 4.494,
    x2: 13.832,
    y1: 7.914,
    y2: 24.086
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#18884f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#117e43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0b6631"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.581 15.35-11.069-1.95v14.409a1.192 1.192 0 0 0 1.193 1.191h19.1a1.192 1.192 0 0 0 1.195-1.191v-5.309z",
    fill: "#185c37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.581 3h-9.876a1.192 1.192 0 0 0 -1.193 1.191v5.309l11.069 6.5 5.861 1.95 4.558-1.95v-6.5z",
    fill: "#21a366"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m8.512 9.5h11.069v6.5h-11.069z",
    fill: "#107c41"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m16.434 8.2h-7.922v16.25h7.922a1.2 1.2 0 0 0 1.194-1.191v-13.868a1.2 1.2 0 0 0 -1.194-1.191z",
    opacity: 0.1
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m15.783 8.85h-7.271v16.25h7.271a1.2 1.2 0 0 0 1.194-1.191v-13.868a1.2 1.2 0 0 0 -1.194-1.191z",
    opacity: 0.2
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m15.783 8.85h-7.271v14.95h7.271a1.2 1.2 0 0 0 1.194-1.191v-12.568a1.2 1.2 0 0 0 -1.194-1.191z",
    opacity: 0.2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m15.132 8.85h-6.62v14.95h6.62a1.2 1.2 0 0 0 1.194-1.191v-12.568a1.2 1.2 0 0 0 -1.194-1.191z",
    opacity: 0.2
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m3.194 8.85h11.938a1.193 1.193 0 0 1 1.194 1.191v11.918a1.193 1.193 0 0 1 -1.194 1.191h-11.938a1.192 1.192 0 0 1 -1.194-1.191v-11.918a1.192 1.192 0 0 1 1.194-1.191z",
    fill: "url(#a)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m5.7 19.873 2.511-3.884-2.3-3.862h1.847l1.255 2.473c.116.234.2.408.238.524h.017c.082-.188.169-.369.26-.546l1.342-2.447h1.7l-2.359 3.84 2.419 3.905h-1.809l-1.45-2.711a2.355 2.355 0 0 1 -.171-.365h-.024a1.688 1.688 0 0 1 -.168.351l-1.493 2.722z",
    fill: "#fff"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m28.806 3h-9.225v6.5h10.419v-5.309a1.192 1.192 0 0 0 -1.194-1.191z",
    fill: "#33c481"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m19.581 16h10.419v6.5h-10.419z",
    fill: "#107c41"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExcel);
export default __webpack_public_path__ + "static/media/excel.4ec1a9d5f045bcfac05efdfc0127d980.svg";
export { ForwardRef as ReactComponent };